<abc-accordion
  class="accordion-style description-container"
  [collapsible]="true"
  [selectedIndex]="0"
  [width]="'100%'"
  [animationDuration]="300"
  [visible]="true"
  [multiple]="false"
  [dataSource]="['Test']"
>
  <div *dxTemplate="let description of 'title'" class="dx-accordion-item-title">
    {{ this.dataService.res('Ubt-MeasureDetail-Description') }}
  </div>
  <div
    fxLayout="column"
    class="card-paddings container-card"
    fxLayoutGap="15px"
    *dxTemplate="let description of 'item'"
  >
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Initial-Situation') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.InitialSituation, 'InitialSituation')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.InitialSituation"
          (onFocusIn)="focusIn(currentMeasure.InitialSituation)"
          (onFocusOut)="focusOut('InitialSituation')"
          (onValueChanged)="handlePaste($event, currentMeasure.InitialSituation, 'InitialSituation')"
          [labelMode]="'floating'"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>

      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Expected-Results') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.ExpectedResults, 'ExpectedResults')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.ExpectedResults"
          (onFocusIn)="focusIn(currentMeasure.ExpectedResults)"
          (onFocusOut)="focusOut('ExpectedResults')"
          (onValueChanged)="handlePaste($event, currentMeasure.ExpectedResults, 'ExpectedResults')"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-CreateMeasure-Objective') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.Goal, 'Goal')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.Goal"
          (onFocusIn)="focusIn(currentMeasure.Goal)"
          (onFocusOut)="focusOut('Goal')"
          (onValueChanged)="handlePaste($event, currentMeasure.Goal, 'Goal')"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Dependencies') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.Dependencies, 'Dependencies')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.Dependencies"
          (onFocusIn)="focusIn(currentMeasure.Dependencies)"
          (onFocusOut)="focusOut('Dependencies')"
          (onValueChanged)="handlePaste($event, currentMeasure.Dependencies, 'Dependencies')"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-Html-Editor-Concept') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.Concept, 'Concept')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.Concept"
          (onFocusIn)="focusIn(currentMeasure.Concept)"
          (onFocusOut)="focusOut('Concept')"
          (onValueChanged)="handlePaste($event, currentMeasure.Concept, 'Concept')"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div>
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Defense-Measures') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(currentMeasure.DefenseMeasures, 'DefenseMeasures')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="currentMeasure.DefenseMeasures"
          (onFocusIn)="focusIn(currentMeasure.DefenseMeasures)"
          (onFocusOut)="focusOut('DefenseMeasures')"
          (onValueChanged)="handlePaste($event, currentMeasure.DefenseMeasures, 'DefenseMeasures')"
          [disabled]="!canEditDescription"
        >
        </dx-html-editor>
      </div>
    </div>
  </div>
</abc-accordion>

<abc-popup
  [height]="540"
  [width]="'50%'"
  [(visible)]="toggleTitleVisible"
  [resizeEnabled]="true"
  title="{{ dataService.res('Ubt-Measure-Detail-Html-Editor-Title') }}"
>
  <div class="dx-card popup-card-paddings card-radius" fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="95">
        {{ dataService.res('Ubt-Html-Editor-' + propertyName) }}
      </div>
      <div fxLayout="column" fxFlex="5">
        <abc-button
          class="edit-text"
          type="default"
          [icon]="'save'"
          [hint]="'Save'"
          [disabled]="!canEditDescription"
          (onClick)="saveChanges(propertyName, fieldValue)"
        >
        </abc-button>
      </div>
    </div>
    <div fxLayout="row">
      <dx-html-editor
        #htmlEditor
        height="350px"
        [width]="'100%'"
        (onValueChanged)="handlePaste($event, fieldValue)"
        [(value)]="fieldValue"
        class="html-editor-style"
        [disabled]="!canEditDescription"

      >
        <dxo-toolbar [multiline]="false">
          <dxi-item name="undo"></dxi-item>
          <dxi-item name="redo"></dxi-item>
          <dxi-item name="color"></dxi-item>
          <dxi-item name="bold"></dxi-item>
          <dxi-item name="italic"></dxi-item>
          <dxi-item name="strike"></dxi-item>
          <dxi-item name="underline"></dxi-item>
          <dxi-item name="alignLeft"></dxi-item>
          <dxi-item name="alignCenter"></dxi-item>
          <dxi-item name="alignRight"></dxi-item>
          <dxi-item name="alignJustify"></dxi-item>
          <dxi-item name="orderedList"></dxi-item>
          <dxi-item name="bulletList"></dxi-item>
          <dxi-item name="insertTable"></dxi-item>
          <dxi-item name="deleteTable"></dxi-item>
          <dxi-item name="insertRowBelow"></dxi-item>
        </dxo-toolbar>
      </dx-html-editor>
    </div>
  </div>
</abc-popup>
